const Step = ({ step: { title, content, step }, index, currentStep }) => {
  const isActiveStep = index + 1 <= currentStep;

  return (
    <div
      className={`app-ai-quote-step ${
        isActiveStep && "app-ai-quote-step-active"
      }`}
    >
      <div className="app-ai-quote-step-count">0{index + 1}</div>
      <div className="app-ai-quote-step-info">
        <div className="app-ai-quote-step-info-header">
          <span>STEP {index + 1}</span>
          <h2>{title}</h2>
        </div>
        {step === currentStep && content && <>{content}</>}
      </div>
    </div>
  );
};

export default Step;
